export default {

    APIToken: process.env.REACT_APP_API_TOKEN,
    APIURLGet: process.env.REACT_APP_API_URL_GET,
    APIURLExec: process.env.REACT_APP_API_URL_EXEC,
    URLUpload: process.env.REACT_APP_URL_UPLOAD,
    S3Bucket: 'fikm',
    S3Region: 'us-east-2',
    S3Key: 'AKIAZ2GISQTLZNYHR3XO',
    S3Secret: '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',
    S3URL: 'https://fikm.s3.us-east-2.amazonaws.com/'

}